export const pt = {
	common: {
		appName: 'BrewAssistant',
		loading: 'Carregando...',
		save: 'Salvar',
		cancel: 'Cancelar',
		delete: 'Excluir',
		edit: 'Editar',
		create: 'Criar',
		back: 'Voltar',
		next: 'Próximo',
		submit: 'Enviar',
		search: 'Buscar',
		filter: 'Filtrar',
		close: 'Fechar',
		confirm: 'Confirmar',
		yes: 'Sim',
		no: 'Não',
		error: 'Erro',
		success: 'Sucesso',
		warning: 'Aviso',
		info: 'Informação'
	},
	nav: {
		home: 'Início',
		batches: 'Lotes',
		recipes: 'Receitas',
		aiAssistant: 'Assistente IA',
		dashboard: 'Minha Conta',
		admin: 'Admin',
		login: 'Entrar',
		logout: 'Sair',
		account: 'Conta',
		preferences: 'Preferências',
		darkMode: 'Modo Escuro',
		lightMode: 'Modo Claro',
		navigation: 'Navegação',
		subtitle: 'Assistente de Cerveja Artesanal',
		activateDarkMode: 'Ativar modo escuro',
		activateLightMode: 'Ativar modo claro',
		language: 'Idioma'
	},
	auth: {
		signIn: 'Entrar',
		signUp: 'Criar Conta',
		email: 'Email',
		password: 'Senha',
		name: 'Nome',
		country: 'País',
		selectCountry: 'Selecione seu país',
		confirmPassword: 'Confirmar Senha',
		forgotPassword: 'Esqueci minha senha',
		confirmCode: 'Código de Confirmação',
		confirmSignUp: 'Confirmar Cadastro',
		createAccount: 'Criar Conta',
		backToLogin: 'Voltar para login',
		entering: 'Entrando...',
		creating: 'Criando...',
		confirming: 'Confirmando...',
		emailPlaceholder: 'voce@exemplo.com',
		passwordPlaceholder: 'Sua senha',
		codePlaceholder: 'Código enviado ao seu email',
		sessionExpired: 'Sessão expirada. Faça login novamente.',
		welcomeBack: 'Bem-vindo de volta!',
		getStarted: 'Comece com o BrewAssistant',
		alreadyHaveAccount: 'Já tem uma conta?',
		dontHaveAccount: 'Não tem uma conta?',
		acceptTerms: 'Aceito os Termos e Condições'
	},
	home: {
		title: 'BrewAssistant - Assistente de Cerveja Artesanal com IA',
		subtitle: 'Use inteligência artificial para entender melhor suas receitas e lotes de cerveja artesanal. Integre com Brewfather e obtenha insights valiosos sobre seu processo de fabricação.',
		viewBatches: 'Ver meus lotes',
		tryAI: 'Experimentar IA',
		brewfatherIntegration: 'Integração Brewfather',
		brewfatherDescription: 'Conecte sua conta Brewfather e sincronize automaticamente seus lotes e receitas.',
		aiAnalysis: 'Análise com IA',
		aiDescription: 'Obtenha insights inteligentes sobre seus lotes e receitas usando inteligência artificial.',
		recommendations: 'Recomendações',
		recommendationsDescription: 'Receba sugestões personalizadas para melhorar suas receitas e processos.',
		features: 'Funcionalidades principais:',
		batchManagement: 'Gestão de Lotes',
		batchManagementDescription: 'Acompanhe todos os seus lotes de cerveja em um só lugar.',
		recipeLibrary: 'Biblioteca de Receitas',
		recipeLibraryDescription: 'Organize e gerencie suas receitas favoritas.',
		aiAssistant: 'Assistente IA',
		aiAssistantDescription: 'Faça perguntas e obtenha respostas inteligentes sobre cerveja artesanal.',
		howItWorks: 'Como funciona:',
		step1: 'Conecte sua conta Brewfather para sincronizar lotes e receitas',
		step2: 'Use o assistente IA para fazer perguntas sobre seus lotes e receitas',
		step3: 'Receba análises e recomendações personalizadas para melhorar seus resultados',
		getStarted: 'Comece agora mesmo',
		createAccount: 'Criar conta',
		startNow: 'Comece agora mesmo',
		createFreeAccount: 'Crie sua conta gratuita e comece a usar o BrewAssistant hoje'
	},
	batches: {
		title: 'Meus Lotes',
		noBatches: 'Nenhum lote encontrado',
		createFirst: 'Criar primeiro lote',
		newBatch: 'Novo Lote',
		syncBrewfather: 'Sincronizar Brewfather',
		syncing: 'Sincronizando...',
		errorLoading: 'Erro ao carregar lotes',
		errorSyncing: 'Erro ao sincronizar com Brewfather',
		syncSuccess: 'Lotes sincronizados com sucesso!',
		noCredentials: 'Credenciais do Brewfather não configuradas',
		noCredentialsDescription: 'Configure suas credenciais da API do Brewfather no Dashboard para visualizar seus lotes.',
		goToDashboard: 'Ir para Dashboard',
		batchNotFound: 'Lote não encontrado',
		backToBatches: 'Voltar para Lotes',
		measurements: 'Medições',
		originalGravity: 'Densidade Original',
		finalGravity: 'Densidade Final',
		notes: 'Notas',
		events: 'Eventos',
		estimated: 'Estimado',
		expected: 'Esperado',
		attenuation: 'Atenuação',
		efficiency: 'Eficiência',
		active: 'Ativo',
		viewRecipe: 'Ver Receita',
		fermentationDuration: 'Duração da Fermentação',
		fermenting: 'fermentando',
		day: 'dia',
		days: 'dias',
		daysRemaining: 'dias restantes',
		complete: 'Completo',
		ago: 'atrás',
		remaining: 'restantes',
		today: 'Hoje',
		overdue: 'Atrasado',
		askAIAboutBatch: 'Perguntar à IA sobre este Lote',
		hideAIChat: 'Ocultar Chat da IA',
		status: {
			planned: 'Planejado',
			brewing: 'Fervendo',
			fermenting: 'Fermentando',
			conditioning: 'Maturação',
			completed: 'Concluído',
			archived: 'Arquivado'
		},
		recipe: 'Receita',
		brewDate: 'Data de Fabricação',
		bottlingDate: 'Data de Envase'
	},
	recipes: {
		title: 'Minhas Receitas',
		noRecipes: 'Nenhuma receita encontrada',
		createFirst: 'Criar primeira receita',
		newRecipe: 'Nova Receita',
		syncBrewfather: 'Sincronizar Brewfather',
		syncing: 'Sincronizando...',
		errorLoading: 'Erro ao carregar receitas',
		errorSyncing: 'Erro ao sincronizar com Brewfather',
		syncSuccess: 'Receitas sincronizadas com sucesso!',
		noCredentials: 'Credenciais do Brewfather não configuradas',
		noCredentialsDescription: 'Configure suas credenciais da API do Brewfather no Dashboard para visualizar suas receitas.',
		goToDashboard: 'Ir para Dashboard',
		type: {
			'all-grain': 'All Grain',
			extract: 'Extrato',
			'partial-mash': 'Partial Mash',
			biab: 'BIAB'
		},
		style: 'Estilo'
	},
	dashboard: {
		title: 'Minha Conta',
		userInfo: 'Informações do Usuário',
		brewfatherIntegration: 'Integração Brewfather',
		brewfatherUserId: 'Brewfather User ID',
		brewfatherUserIdHelper: 'Encontre seu User ID nas configurações da API do Brewfather',
		brewfatherApiKey: 'Brewfather API Key',
		brewfatherApiKeyHelper: 'Mantenha sua API Key segura e não compartilhe com ninguém',
		saveCredentials: 'Salvar Credenciais',
		credentialsSaved: 'Credenciais do Brewfather salvas!',
		setupGuide: 'Como Obter Credenciais da API',
		openaiIntegration: 'Chave da API OpenAI (opcional)',
		openaiDescription: 'Use sua própria chave da API OpenAI para recursos de IA (assistente, análise de lotes). Se não definida, a chave padrão será usada.',
		openaiApiKey: 'Chave da API OpenAI',
		openaiApiKeyHelper: 'Obtenha sua chave em platform.openai.com. Sua chave é armazenada com segurança e usada apenas para suas solicitações.',
		openaiSaved: 'Chave da API OpenAI salva.',
		openaiDeleted: 'Chave da API OpenAI removida.',
		subscription: 'Assinatura',
		subscriptionPlan: 'Plano',
		freePlan: 'Plano gratuito',
		youAreOnPlan: 'Você está no plano {plan}',
		changePlan: 'Alterar',
		manageSubscription: 'Gerenciar assinatura'
	},
	brewfatherSetup: {
		title: 'Guia de Configuração da API do Brewfather',
		introduction: 'Introdução',
		introductionText: 'Para usar o BrewAssistant com sua conta do Brewfather, você precisa obter suas credenciais da API. Este guia o orientará pelo processo passo a passo.',
		step1Title: 'Passo 1: Acessar Configurações do Brewfather',
		step1Description: 'Faça login na sua conta do Brewfather e navegue até a página de configurações da API. Você pode acessá-la diretamente nas configurações da sua conta.',
		openBrewfatherSettings: 'Abrir Configurações da API do Brewfather',
		step2Title: 'Passo 2: Encontrar sua API Key',
		step2Description: 'Na página de configurações da API, você encontrará sua API Key. Esta é uma longa string de caracteres que atua como senha para acesso à API. Copie esta chave.',
		apiKeyLocation: 'Configurações → API → API Key',
		step3Title: 'Passo 3: Encontrar seu User ID',
		step3Description: 'Na mesma página de configurações da API, você também encontrará seu User ID. Isso geralmente é exibido próximo à API Key. Copie este ID também.',
		userIdLocation: 'Configurações → API → User ID',
		step4Title: 'Passo 4: Inserir Credenciais no BrewAssistant',
		step4Description: 'Depois de ter sua API Key e User ID, vá para o Dashboard no BrewAssistant e insira-os na seção de Integração Brewfather.',
		checklist1: 'API Key foi copiada corretamente',
		checklist2: 'User ID foi copiado corretamente',
		checklist3: 'Ambas as credenciais foram salvas no Dashboard',
		importantNotes: 'Notas Importantes',
		note1Title: 'Segurança',
		note1Text: 'Sua API Key é informação sensível. Nunca a compartilhe publicamente ou a envie para controle de versão. Ela fornece acesso completo aos seus dados do Brewfather.',
		note2Title: 'Regeneração da API Key',
		note2Text: 'Se você suspeitar que sua API Key foi comprometida, você pode regenerá-la nas configurações do Brewfather. Você precisará atualizá-la no BrewAssistant após a regeneração.',
		note3Title: 'Acesso aos Dados',
		note3Text: 'A API Key permite que o BrewAssistant leia seus lotes e receitas em tempo real. Nenhum dado é armazenado permanentemente no BrewAssistant - tudo é buscado diretamente do Brewfather.',
		goToDashboard: 'Ir para Dashboard'
	},
	openaiSetup: {
		title: 'Guia de Configuração da Chave de API OpenAI',
		introduction: 'Introdução',
		introductionText: 'Para usar sua própria chave de API OpenAI para recursos de IA (assistente, análise de lote), você precisa criar uma conta OpenAI e gerar uma chave de API. Este guia o orientará pelo processo passo a passo.',
		step1Title: 'Passo 1: Criar uma Conta OpenAI',
		step1Description: 'Se você ainda não tem uma conta OpenAI, cadastre-se em platform.openai.com. Você precisará fornecer informações de pagamento, pois a OpenAI cobra com base no uso.',
		createOpenAIAccount: 'Criar Conta OpenAI',
		step2Title: 'Passo 2: Navegar até Chaves de API',
		step2Description: 'Depois de fazer login, vá para a seção de Chaves de API na sua conta OpenAI. É aqui que você pode criar e gerenciar suas chaves de API.',
		openAPIKeysPage: 'Abrir Página de Chaves de API',
		apiKeyLocation: 'Plataforma → Chaves de API → Criar nova chave secreta',
		step3Title: 'Passo 3: Criar uma Nova Chave de API',
		step3Description: 'Clique em "Criar nova chave secreta" e dê um nome (por exemplo, "BrewAssistant"). Copie a chave imediatamente - você não poderá vê-la novamente! A chave começará com "sk-".',
		apiKeyFormat: 'Formato: sk-... (começa com "sk-" seguido de uma string longa)',
		step4Title: 'Passo 4: Inserir Chave de API no BrewAssistant',
		step4Description: 'Depois de ter sua chave de API, vá para o Dashboard no BrewAssistant e insira-a na seção de Integração OpenAI. Sua chave será armazenada com segurança e usada apenas para suas solicitações.',
		checklist1: 'Chave de API foi copiada corretamente (começa com "sk-")',
		checklist2: 'Chave de API foi salva no Dashboard',
		checklist3: 'Você pode testá-la usando o Assistente de IA ou executando uma análise de lote',
		importantNotes: 'Notas Importantes',
		note1Title: 'Segurança',
		note1Text: 'Sua Chave de API é informação sensível. Nunca a compartilhe publicamente, envie para controle de versão ou exponha em código do lado do cliente. Ela fornece acesso à sua conta OpenAI e uso.',
		note2Title: 'Uso e Cobrança',
		note2Text: 'A OpenAI cobra com base no uso da API. Você pode monitorar seu uso e definir limites de gastos nas configurações da sua conta OpenAI. O BrewAssistant usa sua chave apenas para suas solicitações.',
		note3Title: 'Opcional',
		note3Text: 'Usar sua própria chave de API é opcional. Se você não definir uma, o BrewAssistant usará uma chave padrão. No entanto, usar sua própria chave oferece mais controle sobre uso e cobrança.',
		note4Title: 'Gerenciamento de Chaves',
		note4Text: 'Você pode criar várias chaves de API, revogá-las ou regenerá-las a qualquer momento na sua conta OpenAI. Se você revogar uma chave, atualize-a no BrewAssistant para continuar usando os recursos de IA.',
		goToDashboard: 'Ir para Dashboard'
	},
	aiAssistant: {
		title: 'Assistente IA',
		description: 'Faça perguntas sobre cerveja artesanal, seus lotes e receitas. Use inteligência artificial para obter insights valiosos.',
		askQuestion: 'Faça uma pergunta',
		questionPlaceholder: 'Ex: Como melhorar o sabor da minha IPA?',
		sendQuestion: 'Enviar Pergunta',
		processing: 'Processando...',
		recentInsights: 'Insights Recentes',
		questionHistory: 'Histórico de Perguntas',
		noQuestions: 'Nenhuma pergunta ainda. Faça sua primeira pergunta!',
		errorAsking: 'Erro ao fazer pergunta',
		answerReceived: 'Resposta recebida!',
		insightTypes: {
			analysis: 'Análise',
			suggestion: 'Sugestão',
			warning: 'Aviso',
			tip: 'Dica'
		}
	},
	footer: {
		copyright: `© ${new Date().getFullYear()} BrewAssistant. Todos os direitos reservados.`,
		privacy: 'Privacidade',
		terms: 'Termos',
		contact: 'Contato'
	},
	notFound: {
		title: '404',
		message: 'Página não encontrada.',
		backHome: 'Voltar ao início'
	}
};
